import React  from 'react'
import PropTypes from 'prop-types'
import Input from 'shared/components/form/Input/Input.component'

import styles from './AmazonS3Inputs.module.scss'

const AmazonS3Inputs = props => {
  const {
    accessKey,
    secretAccessKey,
    region,
    // endpoint,
    bucketName,
    isFetching,
    isSaving,
    updateExportApiConfig
  } = props

  return (
    <>
      <Input
        className={styles.input}
        title={'Access Key'}
        value={accessKey}
        onChange={updateExportApiConfig('accessKey')}
        disabled={isFetching || isSaving}
      />
      <Input
        className={styles.input}
        title={'Secret Access Key'}
        value={secretAccessKey}
        onChange={updateExportApiConfig('secretAccessKey')}
        disabled={isFetching || isSaving}
      />
      <Input
        className={styles.input}
        title={'Region'}
        value={region}
        onChange={updateExportApiConfig('region')}
        disabled={isFetching || isSaving}
      />
      {/* <Input
        className={styles.input}
        title={'Endpoint'}
        value={endpoint}
        onChange={updateExportApiConfig('endpoint')}
        disabled={isFetching || isSaving}
      /> */}
      <Input
        className={styles.input}
        title={'Bucket Name'}
        value={bucketName}
        onChange={updateExportApiConfig('bucketName')}
        disabled={isFetching || isSaving}
      />
    </>
  )
}

AmazonS3Inputs.propTypes = {
  accessKey: PropTypes.string,
  secretAccessKey: PropTypes.string,
  region: PropTypes.string,
  // endpoint: PropTypes.string,
  bucketName: PropTypes.string,
  isFetching: PropTypes.bool,
  isSaving: PropTypes.bool,
  updateExportApiConfig: PropTypes.func
}

export default AmazonS3Inputs
